export default __webpack_public_path__ + "static/media/6.cdc5b4c8.png";